import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Badge from '@material-ui/core/Badge';

const styles = (theme) => ({
  root: {
    width: '100%',
  },
  badge: {
    top: 10,
    marginRight: theme.spacing.unit * 1.5,
    minWidth: theme.spacing.unit * 3,
    maxHeight: theme.spacing.unit * 2,
    fontSize: 14,
  },
  colorPrimary: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.secondary.main,
  },
});

class ListItemBadge extends PureComponent {
  render() {
    const { badgeContent, classes, children, selected, ...other } = this.props;

    return (
      <Badge
        badgeContent={badgeContent || 0}
        classes={{
          root: classes.root,
          badge: classes.badge,
          colorPrimary: classes.colorPrimary,
        }}
        color="primary"
        showZero={false}
        {...other}
      >
        {children}
      </Badge>
    );
  }
}

ListItemBadge.propTypes = {
  badgeContent: PropTypes.string,
  classes: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
  selected: PropTypes.bool,
};

ListItemBadge.defaultProps = {
  selected: false,
};

export default withStyles(styles)(ListItemBadge);
